import CookieHelper from './cookie';

if (!CookieHelper.has('cq-opt-out') && !CookieHelper.has('cq-opt-in')) {
    CookieHelper.set('cq-opt-out', 1, { expires: 365 });
}
